import styles from './SynthControls.module.css';
import Slider from "../Slider/Slider";
import SourceSelector from "../SourceSelector/SourceSelector";
import { useSynthControls } from '../../hooks/useSynthControls';

export default function SynthControls({ sendCommand }) {
    const {
        gainSlider,
        gainActual,
        sourceType,
        waveform,
        harmonicPreset,
        handleGainChange,
        handleSourceTypeChange,
        handleWaveformChange,
        handleHarmonicPresetChange
    } = useSynthControls(sendCommand);
    return (
        <div className={styles.section}>
            <div className={styles.container}>
                <h2 className={styles.header}>Synth Controls</h2>
                <div className={styles.controlsFrame}>
                <SourceSelector
                    sourceType={sourceType}
                    waveform={waveform}
                    harmonicPreset={harmonicPreset}
                    onSourceTypeChange={handleSourceTypeChange}
                    onWaveformChange={handleWaveformChange}
                    onHarmonicPresetChange={handleHarmonicPresetChange}
                />
                <Slider
                    label="Gain"
                    value={gainSlider}
                    onChange={handleGainChange}
                    displayValue={gainActual.toFixed(2)}
                />
            </div>
            </div>
        </div>
    );
}
